import pluralize from "pluralize";

// Add custom rule for "needs"
pluralize.addSingularRule(/need$/i, "needs");
pluralize.addPluralRule(/needs$/i, "need");

export default pluralize;
